// HorizontalBarSimple.jsx
import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import useExportChartImage from "../useExportChartImage";
import SaveButton from "../UI/SaveButton";
import { getCategoryLabelById } from "../../../utils/labelsById";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const isRange = (label) => {
  const rangePattern = /(\d+)\s*[-–]\s*(\d+)/;
  return rangePattern.test(label);
};

// Merr fillimin e rangut për ta përdorur në sortim
const getRangeStart = (label) => {
  const match = label.match(/(\d+)\s*[-–]\s*(\d+)/);
  if (match) return parseInt(match[1], 10);
  if (/Deri\s+ne\s+1/i.test(label)) return 0;
  if (/(\d+)/.test(label)) return parseInt(label.match(/(\d+)/)[1], 10);
  return Infinity;
};

// Bën renditjen vetëm nëse të paktën një label është range
const sortEntries = (entries) => {
  const hasRange = entries.some(
    ([label]) => isRange(label) || /Deri\s+ne\s+1/i.test(label)
  );
  if (!hasRange) return entries;

  return [...entries].sort((a, b) => getRangeStart(a[0]) - getRangeStart(b[0]));
};

const HorizontalBarSimple = ({ dataChart = {}, dataSetting, title }) => {
  const chartRef = useRef();
  const exportChartImage = useExportChartImage();
  const fileName = dataSetting?.name + "_" + dataSetting?.year;

  // Krijo të dhënat me renditje sipas range nëse aplikohet
  const entries = sortEntries(Object.entries(dataChart));

  const total = entries.reduce((sum, [, value]) => sum + value, 0);

  const chartData = {
    labels: entries.map(([label]) => label),
    datasets: [
      {
        label: "",
        data: entries.map(([, value]) => ((value / total) * 100).toFixed(2)),
        backgroundColor: "#EC2100",
        borderRadius: 0,
        barThickness: 30,
      },
    ],
  };

  const chartOptions = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`,
        },
      },
      datalabels: {
        anchor: "end",
        align: "right",
        formatter: (value) => `${value}%`,
        color: "#000",
        font: {
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        min: 0,
        max: 70,
        ticks: {
          callback: (value) => `${value}%`,
        },
      },
      y: {
        ticks: {
          font: {
            size: 14,
          },
        },
      },
    },
  };

  const handleExportImage = () => {
    exportChartImage({
      chartRef,
      fileName,
      dataSetting,
    });
  };

  return (
    <div>
      <div ref={chartRef}>
        {title && (
          <h3 style={{ marginBottom: "20px" }}>
            {getCategoryLabelById(title)}
          </h3>
        )}

        <Bar data={chartData} options={chartOptions} />
      </div>
      <SaveButton onClick={handleExportImage} />
    </div>
  );
};

export default HorizontalBarSimple;
